import React, { useState, useEffect } from 'react';
import { BRAND } from '../brand';

const SplashScreen = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Mostrar splash por 2 segundos, luego hacer fade out
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 1800);

    // Llamar onFinish después del fade out
    const finishTimer = setTimeout(() => {
      onFinish();
    }, 2300);

    return () => {
      clearTimeout(timer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-white transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <img 
        src="/logo-oficial.png" 
        alt={`${BRAND.name}`} 
        className="w-48 h-auto animate-pulse"
        style={{
          animation: 'logoFadeIn 0.8s ease-out'
        }}
      />
      
      <style>{`
        @keyframes logoFadeIn {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;
